require('./bootstrap');

window.parseAxiosError = function (error) {
    if (error.response && error.response.data.errors) {
        return error.response.data.errors;
    }

    return ['A apărut o eroare. Vă rugăm să încercați din nou.'];
}
